import { createSelector } from '@reduxjs/toolkit';

const getTestimonialsState = (state) => state.get('testimonials');
export const getTestimonials = (state) => {
  const data = getTestimonialsState(state).get('data');
  return data ? data.toJS() : null;
};
export const getTestimonialsFetching = (state) =>
  getTestimonialsState(state).get('fetching');
export const getTestimonialIds = createSelector(
  getTestimonials,
  (testimonials) =>
    testimonials ? testimonials.map((item) => item.id).join(',') : undefined,
);
